const processRangeInDays = (min = 0, max, seconds_in_day = 86400000) => {
  const ranges = [];
  let x = min;
  for (let i = 0; x <= max; i++) {
    const [, mmm, dd] = new Date(x).toDateString().split(' ');
    ranges.push({ start: x, end: x + seconds_in_day - 1000, label: `${mmm} ${dd}` });
    x += seconds_in_day;
  }

  return ranges;
};

const processRangeInWeeks = (min = 0, max, seconds_in_day = 86400000) => {
  const ranges = [];
  let x = min;
  for (let i = 0; x <= max; i++) {
    const [, mmm, dd] = new Date(x).toDateString().split(' ');
    ranges[i] = {
      start: x,
      end: x + 6 * seconds_in_day - 1000,
      label: `${mmm} ${dd}`
    };
    x += 6 * seconds_in_day;
  }

  return ranges;
};

const processRangeInMonths = (min, max) => {
  // group in months
  const d = new Date(min);
  const year = d.getFullYear();
  const month = d.getUTCMonth();

  const ranges = [];
  let x = min;
  for (let i = 1; x <= max; i++) {
    const [, mmm, , yyyy] = new Date(x).toDateString().split(' ');
    ranges.push({
      start: x,
      end: Date.parse(new Date(year, month + i, 1)) - 1000,
      label: `${mmm} ${yyyy}`
    });

    x = Date.parse(new Date(year, month + i, 1));
  }

  return ranges;
};

export const processDateRange = (start, stop) => {
  const min = Date.parse(start);
  const max = Date.parse(stop);
  const difference = max - min;
  const seconds_in_day = 86400000;

  let ranges = [];
  if (difference / seconds_in_day <= 31) {
    ranges = processRangeInDays(min, max, seconds_in_day);
  } else if (difference / seconds_in_day <= 100) {
    ranges = processRangeInWeeks(min, max, seconds_in_day);
  } else {
    ranges = processRangeInMonths(min, max);
  }

  return ranges;
};
